import VIEW_TYPES from "./../utils/viewTypes"

const VIEW_ATTRIBUTES = {
  id: "modules/analytics/schema/viewAttributes",
  type: "object",
  properties: {
    view_type: {
      type: "string",
      enum: Object.values(VIEW_TYPES),
    },
    view_name: {
      type: "string",
    },
  },
  required: ["view_type", "view_name"],
}

export default VIEW_ATTRIBUTES
